import { Badge } from './badge'

import { PosModel } from '@/types'

/** Inventory at a glance: grey when healthy, amber when low, red when gone. */
export const StockBadge = ({ product, className }: { product: PosModel.Product; className?: string }) => {
  if (product.stock <= 0)
    return (
      <Badge tone="error" className={className}>
        Out of stock
      </Badge>
    )
  if (product.stock <= product.low_stock_threshold)
    return (
      <Badge tone="warning" className={className}>
        {product.stock} left
      </Badge>
    )
  return (
    <Badge tone="soft" className={className}>
      {product.stock} in stock
    </Badge>
  )
}
